module.exports = __webpack_public_path__ + "static/img/众绘logo-01.73e1d94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/众绘logo-01.jpg
// module id = a1iR
// module chunks = 3